import BaseHttp from '../../../plugins/baseHttp';

const get = ({ page, _id, name, },) => {
  const offset = ((page || 1) - 1) * 15;

  if (_id) {return BaseHttp.get(`/logisticOperators/${_id}`,);}

  return BaseHttp.get(
    `/logisticOperators?name=/${name ||
    '.'}/i&fields=name,address.city,address.state,responsible,drivers,stores,published&limit=15&offset=${offset}`,
  );
};

const getLogisticOperatorStores = ({ _id, },) => {
  return BaseHttp.get(
    `/stores?logisticOperator_id=${_id}&fields=name,address.city,address.state,published&sort=-created_at&limit=3&offset=0`,
  );
};

const getLogisticOperatorDrivers = ({ _id, },) => {
  return BaseHttp.get(
    `/drivers?logisticOperator_id=${_id}&fields=full_name,average_rating,status&sort=-created_at&limit=3&offset=0`,
  );
};

const post = (logisticOperator,) => {
  return BaseHttp.post('/logisticOperators', logisticOperator,);
};

const patch = (logisticOperatorId, body,) => {
  return BaseHttp.patch(`/logisticOperators/${logisticOperatorId}`, body,);
};

const postAttachment = (logisticOperatorId, body,) => {
  return BaseHttp.post(`/logisticOperators/${logisticOperatorId}/attachments`, body,);
};

const removeAttachment = (logisticOperatorId, attachmentId,) => {
  return BaseHttp.delete(`/logisticOperators/${logisticOperatorId}/attachments/${attachmentId}`,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  get,
  getLogisticOperatorStores,
  getLogisticOperatorDrivers,
  post,
  patch,
  postAttachment,
  removeAttachment,
  handleError,
};
